import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import TaskJobDetails from './TaskJobDetails';
import authService from './api-authorization/AuthorizeService';

interface JobPayment {
    id: number;
    jobDetails: JobDetails;
    moneyPaidId: number;
    sendEmail: boolean;
    loading: boolean;
    errors: any;
}

interface JobDetails {
    jobId: number;
    customer: string;
    customerContact: string;
    mobile: string;
    phone: string;
    email: string;
    siteAddress: string;
    lotNumber: string;
    items: ItemList[];
    totalAmount: string;
}

interface ItemList {
    id: number;
    paid: boolean;
    item: string;
    type: string;
    hirePeriodDays: string;
    quantityMeasure: string;
    amountFormatted: string;
    overhireRateFormatted: string;
    scheduleDate: string;
}

interface INameToValueMap {
    [key: string]: any;
}

export class TaskFollowUpPrepaidPaymentData extends React.Component<RouteComponentProps<{}>, JobPayment> {
    constructor(props: any) {
        super(props);
        this.state = {
            id: 0,
            jobDetails: {
                jobId: 0,
                customer: "",
                customerContact: "",
                mobile: "",
                phone: "",
                email: "",
                siteAddress: "",
                lotNumber: "",
                items: [],
                totalAmount: "$0.00"
            },
            moneyPaidId: -1,
            sendEmail: false,
            loading: true,
            errors: {}
        };
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let jobParams: INameToValueMap = {};
        jobParams["id"] = 0;
        jobParams = this.props.match.params;
        let Id = jobParams["id"];
        this.setState({ id: Id });

        axios.get('api/User/CheckUserPermission?Permission=RunFollowUpPrepaidPaymentTask&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                //assign task to current user
                var taskdetails = {
                    Id: Id,
                    SubId: user.sub
                };
                axios.post('api/Tasks/AssignTask', taskdetails, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    //this needs to just happen in the background
                });

                axios.get('api/Tasks/GetTaskFollowUpPrepaidPaymentDetails?Id=' + Id, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    this.setState({ id: Id, jobDetails: res.data, loading: false });
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleMoneyPaidChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        var jobdetails = this.state.jobDetails;
        if (e.target.value == 1) {
            //all money paid so make sure all tickboxes in grid are ticked
            for (var i = 0; i < jobdetails.items.length; i++) {
                var item = jobdetails.items[i];
                item.paid = true;
            }
        }
        if (e.target.value == 3) {
            //money not paid so make sure tickboxes in grid are cleared
            for (var i = 0; i < jobdetails.items.length; i++ ) {
                var item = jobdetails.items[i];
                item.paid = false;
            }
        }

        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = errors;
        change["jobDetails"] = jobdetails;
        this.setState(change);
    }

    handleCheckboxChange = (e: any) => {
        let change: any = {};
        change[e.target.name] = e.target.checked;
        this.setState(change);
    }

    onCellChange = (itemIndex: number, item: string, value: any) => {
        //update item that has changed
        var jobDetails = this.state.jobDetails;
        var jobDetailItem = jobDetails.items[itemIndex];
        let newJobDetailItem: any = {};
        newJobDetailItem = jobDetailItem;
        newJobDetailItem[item] = value;

        this.setState({ jobDetails: jobDetails });
    }

    validate = () => {
        let formIsValid = true;
        let errors: any = {};

        let itemPaidCount = this.state.jobDetails.items.filter(x => x.paid).length;

        if (this.state.moneyPaidId < 1) {
            formIsValid = false;
            errors["moneyPaidId"] = "Has money been paid is required";
        } else if (this.state.moneyPaidId == 1 && itemPaidCount < this.state.jobDetails.items.length) {
            formIsValid = false;
            errors["items"] = "Select all item/s that have been paid or change the money paid to 'Yes - Some Paid'";
        } else if (this.state.moneyPaidId == 2 && itemPaidCount == 0) {
            formIsValid = false;
            errors["items"] = "Select item/s that have been paid";
        } else if (this.state.moneyPaidId == 2 && itemPaidCount == this.state.jobDetails.items.length) {
            formIsValid = false;
            errors["items"] = "Unselect item/s that have not been paid or change the money paid to 'Yes - All Paid'";
        } else if (this.state.moneyPaidId == 3 && itemPaidCount > 0) {
            formIsValid = false;
            errors["items"] = "Unselect item/s set to paid or change money paid to another option";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    submit = (e: any) => {
        e.preventDefault();
        if (this.validate()) {
            this.save();
        } else {
            //alert("Form has errors.")
        }
    }

    async save() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var items = [];

        for (var i = 0; i < this.state.jobDetails.items.length; i++) {
            var item = this.state.jobDetails.items[i];
            items.push({ id: item.id, paid: item.paid });
        }

        var details = {
            taskId: this.state.id,
            jobId: this.state.jobDetails.jobId,
            moneyPaid: (this.state.moneyPaidId == 1 || this.state.moneyPaidId == 2) ? true : false,
            sendEmail: this.state.sendEmail,
            items: items,
            subId: user.sub
        };

        axios.post('api/Tasks/SaveFollowUpPrepaidPayment', details, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Task Saved");
            this.props.history.push("/tasks")
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            <h1>Follow Up Prepaid Payment</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var jobDetails = this.state.jobDetails;
        var phone = jobDetails.mobile != "" && jobDetails.phone != "" ? jobDetails.mobile + " or " + jobDetails.phone : jobDetails.mobile != "" ? jobDetails.mobile : jobDetails.phone;
        let taskJobDetails = <TaskJobDetails jobDetails={jobDetails} />

        return (
            <form name="jobDetails" onSubmit={this.submit}>
                <div>
                    <span>Check Accounting Software to see if {jobDetails.customer} has paid for the below job:</span>
                    {taskJobDetails}
                    <div>
                        <div className="table__margin overflowAuto">
                            <table className="table table__large tableColours">
                                <thead>
                                    <tr>
                                        <th className="hidden">Id</th>
                                        <th>Paid</th>
                                        <th>Item</th>
                                        <th>Type</th>
                                        <th>Hire Period</th>
                                        <th>Quantity</th>
                                        <th>Amount</th>
                                        <th>Overhire Rate</th>
                                        <th>Schedule Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jobDetails.items.map((item, index) =>
                                        <tr key={index}>
                                            <td className="hidden">{item.id}</td>
                                            <td><input type='checkbox' className="input" checked={item.paid} onChange={(e) => this.onCellChange(index, "paid", e.target.checked)} /></td>
                                            <td className="table__text--align">{item.item}</td>
                                            <td className="table__text--align">{item.type}</td>
                                            <td className="table__text--align">{item.hirePeriodDays}</td>
                                            <td className="table__text--align">{item.quantityMeasure}</td>
                                            <td className="table__text--align">{item.amountFormatted}</td>
                                            <td className="table__text--align">{item.overhireRateFormatted}</td>
                                            <td className="table__text--align">{item.scheduleDate}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <span className="label errors">{this.state.errors["items"]}</span>
                        </div>
                        <div className="job__quote--amount">
                            <span>Total Outstanding {this.state.jobDetails.totalAmount}</span>
                        </div>
                    </div>
                    <div>
                        <label htmlFor="moneyPaidId">
                            <span className="label tasks__labelsize">Has money been paid?</span>
                            <select className="select" id="moneyPaidId" name="moneyPaidId" value={this.state.moneyPaidId} onChange={(e) => this.handleMoneyPaidChange(e)}>
                                <option hidden defaultValue="-1"></option>
                                <option value="1">Yes - All Paid</option>
                                <option value="2">Yes - Some Paid</option>
                                <option value="3">No - Not Paid</option>
                            </select>
                        </label>
                        <span className="label errors">{this.state.errors["moneyPaidId"]}</span>
                    </div>
                    <br></br>
                    <div className={this.state.moneyPaidId == 2 || this.state.moneyPaidId == 3 ? "" : "hidden"}>
                        <span>Please call {jobDetails.customerContact} from {jobDetails.customer} on {phone} to get{this.state.moneyPaidId == 2 ? " remaining" : ""} payment</span>
                    </div>
                    <div className="hidden">
                        <label className="input-group" htmlFor="sendEmail">
                            <span className="label">Send an email reminder to {this.state.jobDetails.customerContact}?</span>
                            <input className="input" type="checkbox" id="sendEmail" name="sendEmail" checked={this.state.sendEmail} onChange={(e) => this.handleCheckboxChange(e)}></input>
                        </label>
                    </div>
                    <br></br>
                    <div className="row">
                        <button className="defaultbutton-prev" type="submit">Save</button>
                    </div>
                </div>
            </form>
        );
    }
}
//class for send email once emails set up
//className={this.state.jobDetails.email == "" ? "hidden" : "" }